import clsx from "clsx";
import Image from "components/Elements/Image/Image";
import useOrganization from "hooks/useOrganization";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain";

import { memo, useEffect } from "react";

import styles from "./logo.module.scss";

interface LogoI extends React.HTMLAttributes<HTMLDivElement> {
  color?: "white" | "black" | "gray" | "yellow";
  replaceWhenOrgDomain?: boolean;
}

const LOGO_IMAGE_NAMES: {
  [key in LogoI["color"]]: string;
} = {
  white: "jumbomail-logo",
  black: "jumbomail-logo-black",
  gray: "jumbomail-M-logo-gray",
  yellow: "jumbomail-logo-small",
};

const JUMBOMAIL_TITLE = "JUMBOMail";
const domain = window.location.hostname;

const Logo = memo((props: LogoI) => {
  const {
    className,
    color = "black",
    replaceWhenOrgDomain,
    ...restProps
  } = props;
  const { logo, fetchLogo } = useOrganization();

  const isCurrDomainOrgDomain = checkCurrDomainIsOrgDomain();

  const name = LOGO_IMAGE_NAMES[color];

  useEffect(() => {
    if (isCurrDomainOrgDomain && replaceWhenOrgDomain) {
      fetchLogo();
    }
  }, [isCurrDomainOrgDomain, replaceWhenOrgDomain]);

  return isCurrDomainOrgDomain && replaceWhenOrgDomain && logo ? (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      <Image src={logo} title={domain} alt={domain} />
    </div>
  ) : !isCurrDomainOrgDomain ? (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      <Image name={name} title={JUMBOMAIL_TITLE} alt={JUMBOMAIL_TITLE} />
    </div>
  ) : null;
});

export default Logo;
